import { render, staticRenderFns } from "./dialog-msg-table.vue?vue&type=template&id=360949a5&scoped=true"
import script from "./dialog-msg-table.vue?vue&type=script&lang=js"
export * from "./dialog-msg-table.vue?vue&type=script&lang=js"
import style0 from "./dialog-msg-table.vue?vue&type=style&index=0&id=360949a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360949a5",
  null
  
)

export default component.exports